module.exports = __webpack_public_path__ + "img/my-things2.58519153.jpg";